/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
class KeyCutter {
  private key: string;

  private delimiterStart: string;

  private delimiterEnd: string;

  private attributes: { [key: string]: string };

  constructor(key: string, delimiters: [string, string] = ['[', ']']) {
    this.key = key;
    this.delimiterStart = delimiters[0];
    this.delimiterEnd = delimiters[1];

    this.setAttributes();
  }

  /**
   * restituisce la key senza gli attributi
   */
  getClean(): string {
    return this.key.substring(this.findCutEnd() + 1);
  }

  /**
   * restituisce il valore dell'attributo
   */
  getAttribute(key: string): string {
    return this.attributes[key];
  }

  /**
   * stabilisce se l'attributo esiste
   */
  hasAttribute(key: string): boolean {
    return typeof this.attributes[key] !== 'undefined';
  }

  /**
   * estrae gli attributi contenuti nella key
   */
  private setAttributes(): void {
    this.attributes = this.getAttributesPart()
      .split('|')
      .reduce((obj, attr) => {
        const pieces = attr.split(':');
        const key = pieces[0];
        const value = pieces[1];

        if (key && value) {
          obj = { ...obj, [key]: value };
        }

        return obj;
      }, {});
  }

  /**
   * restitusce la parte di stringa che contiene gli attributi
   */
  private getAttributesPart(): string {
    const start = this.findCutStart();
    const end = this.findCutEnd();

    if (start < 0 || end < 0 || start === end) {
      return '';
    } else {
      return this.key.substring(start + 1, end);
    }
  }

  /**
   * trova l'inzio per tagliare il pezzo di stringa
   */
  private findCutStart(): number {
    return this.key.indexOf(this.delimiterStart);
  }

  /**
   * trova la fine per tagliare il pezzo di stringa
   */
  private findCutEnd(): number {
    return this.key.indexOf(this.delimiterEnd);
  }
}

export default KeyCutter;
